import React from "react";
import "./Hero.css";
import HeroTwo from "./HeroTwo";
import Explore from "../ExploreAlbum/Explore";
import ServicesSection from "../ExploreAlbum/ServiceSection";
import SpecialitySection from "../ExploreAlbum/SpecialitySection";
import Banner from "./Banner";
import BannerStrip from "./BannerStrip";
import { FaCrown } from "react-icons/fa";
import Keephundred from "../ExploreAlbum/Keephundred";
import Pricing from "../ExploreAlbum/Pricing";
import Reach from "../ExploreAlbum/Reach";
// import Testimonial from "../Testimonial/Testimonial";
import MusicUpload from "../ExploreAlbum/MusicUpload";
import RightChoice from "../ExploreAlbum/RightChoice";
import HallOfFame from "../ExploreAlbum/HallOfFame";
import Testimonial from "../Testimonial/Testi/Testimonial";
import OtherServices from "../../Services/RightsManagement/OtherServices";
import LastComponent from "../../Services/RightsManagement/LastComponent";
import Faq from "../../Faqs/Faq";
import StoreStrip from "../../SellMusic/StoreStrip";
// import Additional from "../ExploreAlbum/Additional";
import { motion, useScroll, useSpring } from "framer-motion";

const Hero = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  const otherServices = [
    {
      heading: "Rights Management",
      para: "Protect your tunes with top music rights management.",
      url: "/music-right-management",
    },
    {
      heading: "Youtube Monetization",
      para: "Earn more with easy YouTube monetization services.",
      url: "/youtube-monetization",
    },
    {
      heading: "Music Publishing",
      para: "Publish your music, reach the world.",
      url: "/music-publishing",
    },
    {
      heading: "Digital Distribution",
      para: "Share your music worldwide, effortlessly.",
      url: "/digital-distribution",
    },
  ];

  return (
    <div className="hero-main-wrapper">
      <motion.div className="progress-bar" style={{ scaleX }} />

      <Banner />
      <StoreStrip />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <SpecialitySection />
      </motion.div>

      <div className="bg-gradient-wrapper-1">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <MusicUpload />
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Pricing />
      </motion.div>

      <div className="bg-image-wrapper-hall">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <HallOfFame />
        </motion.div>
      </div>

      <div className="bg-gradient-wrapper-reach">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Reach />
        </motion.div>
      </div>

      <div className="bg-gradient-wrapper-dashboard">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <RightChoice />
        </motion.div>
      </div>

      <div className="bg-gradient-wrapper-testi">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <Testimonial />
        </motion.div>
      </div>

      <div className="music_services_enhanced">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <OtherServices otherServices={otherServices} />
          <LastComponent
            headingbefore="Digital Distribution Services - "
            mark="Unlimited Releases"
            detail="Distribute Now"
          />
        </motion.div>
      </div>

      <Faq />
    </div>
  );
};

export default Hero;
